
import { sendError } from '@/helpers/sentry';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import PrinterListBody from '@/components/jobDetailed/printerList/PrinterListBody.vue';
import { getUserPrinters } from '@/api';
import { UserPrintersData } from '@/models/main';

@Component({
  components: {
    PrinterListBody,
  },
})
export default class PrinterListLoadBody extends Vue {
  @Prop(Boolean) public isShow: boolean;
  @Prop(Function) public printRequest: (printerId: number) => Promise<AxiosResponse>;
  @Prop(Function) public close: () => void;

  public loading = false;
  public printers: UserPrintersData[] = [];

  @Watch('isShow', { immediate: true })
  private watchIsShow(isShow: boolean) {
    if (isShow) {
      this.fetchData();
    }
  }

  private fetchData(): void {
    this.loading = true;
    this.printers = [];
    getUserPrinters()
      .then((printers: UserPrintersData[]) => {
        this.printers = printers;
      })
      .catch(err => {
        sendError(err, 'PrinterListLoadBody');
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
